import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getAllTicketBySlug, getAllVenueBySlug, updateTicket } from "../../../api";
import { getAllTicketGroupBySlug } from "../../../api";
import { createTicket, deleteTicket } from "../../../api";
import NormalTable from "../../../components/common/Tables/NormalTable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PulseLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { handleError } from "../../../utils/errorHandler";
import moment from "moment";
import CommonSelect from "../../../components/common/Select/CommonSelect";
import { current } from "@reduxjs/toolkit";
import ListCard from "../../../components/common/ListCard/ListCard";
import NewTicketModal from "../../Events/CreateQickEventV2/Components/NewTicketModal";
import { EventFormData, TicketData, VenueData, TicketGroupData } from "../../Events/CreateQickEventV2/types"


const UserTickets = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ticketKind, setTicketKind] = useState<'single' | 'group'>('single');
  const [hasMultipleVenues, setHasMultipleVenues] = useState(false);
  const [tickets, setTickets] = useState<TicketData[]>([]);
  const [venues, setVenues] = useState<VenueData[]>([]);
  const [ticketGroups, setTicketGroups] = useState<TicketGroupData[]>([]);
  const [isTicketFree, setIsTicketFree] = useState(false);
  const { slug } = useParams();
  const [ticket, setTicketList] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [hasMultipleTicketGroups, setHasMultipleTicketGroups] = useState(false);
  const [showGroupTicketField, setShowGroupTicketField] = useState(false);
  const toggle = () => setModal(!modal);
  const [isLoading, setIsLoading] = useState(true);
  const [hasGroupTickets, setHasGroupTickets] = useState(false);
  const [groupTicketList, setGroupTicketList] = useState<any[]>([]);
  const [eventVenuesForAdd, setEventVenuesForAdd] = useState<any[]>([]);
  const [showVenueField, setShowVenueField] = useState(false);
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [selectedVenueForAdd, setSelectedVenueForAdd] = useState<any>(null);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({ id: "", ticketType: "", ticketStatus: "", description: "" });
  const [selectedGroupSorting, setSelectedGroupSorting] = useState("0");
  const [filteredTickets, setFilteredTickets] = useState<any>([]);
  const [hasVenue, setHasVenue] = useState(false);
  const toggleEditModal = () => setEditModal(!editModal);
  useEffect(() => {
    getTicketList();
    checkIfEventHasGroupTickets();
    getEventVenue();
  }, [slug]);
  const openModal = (type: 'single' | 'group') => {
    setTicketKind(type);
    setIsModalOpen(true);
  };
   const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
    const handleTicketSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const eventData = localStorage.getItem("eventData");
      const venueId = localStorage.getItem("venueId");
      if (!eventData) return;
  
      const eventSlug = JSON.parse(eventData).slugId;
  
      const payload = {
        ...values,
        eventSlug,
        venueId,
        ticketGroupId: hasMultipleTicketGroups ? values.ticketGroupId : null,
        price: isTicketFree ? 0 : values.price,
        maxCount: values.maxCount === 0 || isNaN(values.maxCount) ? null : values.maxCount,
        isGroupTicket: ticketKind === "group",
        groupTicketCount: ticketKind === "group" ? values.groupTicketCount : 0,
        ticketOrder: null,
        ticketStatus: "active"
      };
  
      await createTicket(payload); 
      toast.success("Ticket created successfully");
  
      await getTicketList();
      setIsModalOpen(false); 
    } catch (error) {
      console.error("Error creating ticket:", error);
      toast.error("Error creating ticket");
    } finally {
      setIsLoading(false);
    }
  };

  const getEventVenue = async () => {
    try {
      setIsLoading(true);
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const slugId = JSON.parse(eventData).slugId;
      const resp = await getAllVenueBySlug(slugId);
      const venueOptions = resp.map((item: any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      setEventVenuesForAdd(venueOptions);
      if (venueOptions.length === 1) {
      validation.setFieldValue("venueId", venueOptions[0].value);
      setSelectedVenueForAdd(venueOptions[0].value);
    }
      const allVenue = {
        value: "0",
        label: "All Venues"
      }
      setEventVenues([allVenue, ...venueOptions])
    } catch (error) {
      handleError(error)
    }
    finally{
      setIsLoading(false);
    }
  }
  const checkIfEventHasGroupTickets = async () => {
  const eventData = localStorage.getItem("eventData");
  if (eventData) {
    const eventSlug = JSON.parse(eventData).slugId;
    const groupTickets = await getAllTicketGroupBySlug(eventSlug);

    if (groupTickets && groupTickets.length > 0) {
      const groupOptions = groupTickets.map((group: any) => ({
        value: group.id,
        label: group.groupName,
      }));

      setGroupTicketList(groupOptions);

      if (groupOptions.length === 1) {
        validation.setFieldValue("groupingId", groupOptions[0].value);
        validation.setFieldValue("groupName", groupOptions[0].label);
      }
    }

    const eventVenues = JSON.parse(eventData).eventVenues;
    if (eventVenues && eventVenues.length > 0) {
      const venues = eventVenues.map((venue: any) => ({
        value: venue._id,
        label: venue.venueName,
      }));
      setEventVenuesForAdd(venues);
    }
  }
};

 const getTicketList = async () => {
    try {
      setIsLoading(true);
      const eventData = localStorage.getItem("eventData");
      const venueId = localStorage.getItem("venueId");
      if (eventData && venueId) {
        const eventSlug = JSON.parse(eventData).slugId;
        const response = await getAllTicketBySlug(eventSlug);
        const filtered = response.filter((ticket :any)  => String(ticket.venueId) === venueId);
        setTicketList(filtered);
        setFilteredTickets(filtered);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      label: "Ticket Name", key: "ticketType", cellContent: (row: any) => {
        return (
        <div>
          <span className="">{row.ticketType}</span><br />
          <span className="">{row.description}</span><br/>
        </div>
      )
    }
    },
    // { label: "Grouping Name", key: "groupName" },
    { label: "Price", key: "price" },
    { label: "Max Count", key: "maxCount",cellContent: (row: any) => <span>{row.maxCount === null ? "Unlimited" : row.maxCount}</span> },
    { label: "Current Count", key: "currentCount" },
    { label: "Is Group Ticket(Count)", key: "isGroupTicket", cellContent: (row: any) => <span>{row.isGroupTicket ? `Yes (${row.groupTicketCount})` : "No"}</span> },
    {
      label: "Status", key: "ticketStatus",
      cellContent: (row: any) => <span className={row.ticketStatus === "active" ? "text-success" : "text-danger"}>{row.ticketStatus.charAt(0).toUpperCase() + row.ticketStatus.slice(1)}</span>
    },
    { label: "Created", key: "createdAt",cellContent: (row: any) => (
      <span>{row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY HH:mm") : ""}</span>
    ) },
   {
  label: "",
  key: "actions",
  cellContent: (row:any) => ( 
    <span className="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
      <span className="text-primary" onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}>
        <i className=" fa-solid fa-pencil"></i>
      </span>
      <span className="text-danger" onClick={() => handleDelete(row)} style={{ cursor: "pointer" }}>
        <i className="fa-solid fa-trash-alt"></i>
      </span>
    </span>
  ),
},
  ];
  const handleSearch = (e:any) => {
  const value = e.target.value.toLowerCase();
  setSearch(value); 
  if (value.length > 0) {
    setFilteredTickets(
      ticket.filter((item: any) =>
        item.ticketType.toLowerCase().includes(value)
      )
    );
  } else {
    setFilteredTickets(ticket);
  }
};

  const handleEdit = (ticket: any) => {
    setEditData({
      id: ticket.ticketTypeId,
      ticketType: ticket.ticketType,
      ticketStatus: ticket.ticketStatus,
      description: ticket.description,
    });
    setEditModal(true);
  };
  const handleDelete = async (ticket: any) => {
  if (window.confirm("Are you sure you want to delete this ticket?")) {
    try {
      const response = await deleteTicket(ticket.ticketTypeId);
      toast.success("Ticket deleted successfully");
      getTicketList();
    } catch (error:any) {
      const errorMsg = error.response?.data?.message ||
        "Failed to delete ticket";
      toast.error(errorMsg);
    }
  }
};
  const editValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ticketType: editData.ticketType || "",
      ticketStatus: editData.ticketStatus || "active",
      description: editData.description || "",
    },
    validationSchema: Yup.object({
      ticketType: Yup.string().required("Ticket name is required"),
      ticketStatus: Yup.string().required("Status is required"),
    }),
   onSubmit: async (values) => {
  try {
    setIsLoading(true);
    if (editData?.id) {
      await updateTicket(editData.id, values);
      toast.success("Ticket updated successfully");
      await checkIfEventHasGroupTickets(); 
      await getEventVenue();               
      if (selectedVenueForAdd !== "0") {
        await onSelectedVenue(selectedVenueForAdd);
        await getTicketList();
      } else {
        await getTicketList();
      }
      toggleEditModal();
    }
  } catch (error) {
    toast.error("Failed to update ticket");
  } finally {
    setIsLoading(false);
  }
}
  });
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ticketType: "",
      price: "",
      maxCount: 0,
      currentCount: 0,
      groupTicketPrice: 0,
      eventSlug: slug,
      ticketOrder: "null",
      ticketStatus: "active",
      groupTicketCount: "",
      groupingId: "",
      isGroupTicket: "",
      description: "",
    },
    validationSchema: Yup.object({
      ticketType: Yup.string().required("Ticket Name Required"),
      price: Yup.number()
        .required("Price Required"),      //   .required("Ticket Order Required")
      //   .positive("Order must be positive"),
      groupTicketCount: Yup.number().when("isGroupTicket", {
        is: true,
        then: () =>
          Yup.number()
            .required("Group Ticket Count Required")
            .min(2, "Group capacity must be at least 2 attendees"),
      }),

    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).slugId;
          const venueId = localStorage.getItem("venueId");
          const groupTicketCount = showGroupTicketField ? values.groupTicketCount : 0;
          const payload = {
            ...values,
            eventSlug,
            isGroupTicket: showGroupTicketField,
            groupTicketCount,
            groupingId: values.groupingId,
            venueId: venueId || null,
            ticketOrder: null,
            maxCount: values.maxCount === 0 ? null : values.maxCount,
          };
          const response = await createTicket(payload);
          toast.success("Ticket Created successfully");
          toggle();
          if (selectedVenueForAdd !== "0") {
            onSelectedVenue(selectedVenueForAdd);
            getTicketList();
          } else {
            getTicketList();
          }
        validation.resetForm();
        if (groupTicketList.length === 1) {
        validation.setFieldValue("groupingId", groupTicketList[0].value);
        validation.setFieldValue("groupName", groupTicketList[0].label);
      }
        }
      } catch (error) {
        console.error("Error creating ticket:", error);
        toast.error("Error creating ticket");
      }
      finally{
        setIsLoading(false);
      }
    },
  });
  useEffect(() => {
  if (groupTicketList.length === 1) {
    const group = groupTicketList[0];
    if (!validation.values.groupingId) {
      validation.setFieldValue("groupingId", group.value);
      validation.setFieldValue("groupName", group.label);
    }
  }
}, [groupTicketList]);
  const onSelectedVenue = async (venueId: any) => {
    setSelectedVenueForAdd(venueId);
    if (venueId === "0") {
      setFilteredTickets(ticket);
    } else {
      const newFiltered = ticket.filter((item: any) => item.venueId === venueId);
      setFilteredTickets(newFiltered);
    }
  };
  const handleGroupSorting = (selectedId: any) => {
    console.log("Selected Group Sorting Value:", selectedId);
    setSelectedGroupSorting(selectedId);
    if (selectedId === "0") {
      setFilteredTickets(ticket);
    } else {
      const newFiltered = ticket.filter((item: any) =>
        String(item.groupingId) === String(selectedId)
      );
      console.log("Filtered Result:", newFiltered);
      setFilteredTickets(newFiltered);
    }
  };
  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-ticket"></i>
                </i>
                Ticket List
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-4">
                    <div className="form-group">
                      <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                        {/* {eventVenuesForAdd.length > 1 && (
                          <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            <CommonSelect
                              options={eventVenues} 
                              value={selectedVenueForAdd}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                              label="Event Venue"
                            />

                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                        )} */}
                        {groupTicketList.length > 1 &&  (
                          <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            {/* <select
                              className="form-control h_40 ps-4 text-light"
                              value={selectedGroupSorting}
                              onChange={(e) => handleGroupSorting(e.target.value)}
                            >
                              <option value="0">All Group Tickets</option>
                              {groupTicketList.map((group: any) => (
                                <option key={group.value} value={group.value}>
                                  {group.label}
                                </option>
                              ))}
                            </select> */}
                            <CommonSelect
                              options={[{ value: "0", label: "All Group Tickets" }, ...groupTicketList]}
                              value={selectedGroupSorting}
                              onChange={(e) => handleGroupSorting(e.target.value)}
                              label="Group Ticket"
                            />
                          </div>
                        )}
                        <div className="search-group position-relative w-100 mb-2 mb-md-0">
                          <input
                            className="form-control h_40"
                            type="text"
                            placeholder="Search by name"
                            value={search}
                            onChange={handleSearch}
                          />
                          <i className="uil uil-search"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rs ms-auto mt-2 mt_r4 px-2 pb-2">
                    <div className="me-2">
                      <div className="d-flex align-items-center justify-content-between pt-4 pb-3 full-width">
                  <div className="dropdown dropdown-default dropdown-normal btn-ticket-type-top">
                    <button className="dropdown-toggle main-btn btn-hover h_40 pe-4 ps-4" type="button">
                      <span>Add Tickets</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a 
                        className="dropdown-item" 
                        href="#" 
                        onClick={(e) => {
                          e.preventDefault();
                          openModal('single');
                        }}
                      >
                        <i className="fa-solid fa-ticket me-2"></i>
                        Single Ticket
                      </a>
                      <a 
                        className="dropdown-item" 
                        href="#" 
                        onClick={(e) => {
                          e.preventDefault();
                          openModal('group');
                        }}
                      >
                        <i className="fa-solid fa-ticket me-2"></i>
                        Group Ticket
                      </a>
                    </div>
                  </div>
                </div>
                      <Modal isOpen={modal} toggle={toggle}>
                        <ModalHeader toggle={toggle}>
                          Add New Ticket
                        </ModalHeader>
                        <Form onSubmit={validation.handleSubmit}>
                          <ModalBody className="px-4">
                            <FormGroup>
                              <Label className="form-label">Ticket Name</Label>
                              <Input
                                name="ticketType"
                                type="text"
                                placeholder="Enter Ticket Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ticketType}
                                invalid={
                                  validation.touched.ticketType &&
                                  !!validation.errors.ticketType
                                }
                              />
                              {validation.touched.ticketType &&
                                validation.errors.ticketType ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ticketType}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Ticket Description</Label>
                              <Input
                                name="description"
                                type="text"
                                placeholder="Enter Ticket Description"
                                value={validation.values.description}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.description && !!validation.errors.description}
                              />
                              {validation.touched.description && validation.errors.description && (
                                <FormFeedback type="invalid">
                                  {validation.errors.description}
                                </FormFeedback>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">
                                Ticket Amount
                              </Label>
                              <Input
                                name="price"
                                type="text"
                                placeholder="Enter Ticket Amount"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.price}
                                invalid={
                                  validation.touched.price &&
                                  !!validation.errors.price
                                }
                              />
                              {validation.touched.price &&
                                validation.errors.price ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.price}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Max Count</Label>
                              <p className="text-warning">* Enter 0 for unlimited availability.</p>
                              <Input
                                name="maxCount"
                                type="text"
                                placeholder="Enter 0 for unlimited availability."
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.maxCount}
                                invalid={
                                  validation.touched.maxCount &&
                                  !!validation.errors.maxCount
                                }
                              />
                              {validation.touched.maxCount &&
                                validation.errors.maxCount ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.maxCount}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={showGroupTicketField}
                                  onChange={(e) =>
                                    setShowGroupTicketField(e.target.checked)
                                  }
                                />{" "}
                                <div className="d-flex flex-column">
                                  <p>Group Ticket</p>
                                  <p className="text-warning">* Choose this if you want to create a group ticket<br/>
                                  * Eg: Family , Couple tickets etc..</p>
                                </div>                                
                              </Label>
                            </FormGroup>
                            <br/>
                            {showGroupTicketField && (
                              <FormGroup>
                                <Label>Good For</Label>
                                 <p className="text-warning">* Number of people allowed per ticket</p>
                                <Input
                                  name="groupTicketCount"
                                  type="number"
                                  placeholder="Enter Group Ticket Count"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.groupTicketCount}
                                  invalid={
                                    validation.touched.groupTicketCount &&
                                    !!validation.errors.groupTicketCount
                                  }
                                />
                                {validation.touched.groupTicketCount &&
                                  validation.errors.groupTicketCount ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.groupTicketCount}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            )}
                            {/* <FormGroup>
                              <Label className="form-label">
                                Ticket Order No
                              </Label>
                              <Input
                                name="ticketOrder"
                                type="text"
                                placeholder="Enter the order no. Eg: 1,2,3"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ticketOrder}
                                invalid={
                                  validation.touched.ticketOrder &&
                                  !!validation.errors.ticketOrder
                                }
                              />
                              {validation.touched.ticketOrder &&
                                validation.errors.ticketOrder ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.ticketOrder}
                                </FormFeedback>
                              ) : null}
                            </FormGroup> */}
                            {/* { eventVenuesForAdd.length > 1 && (
                              <FormGroup>
                                <Label>Event Venue</Label>
                                <Input
                                  type="select"
                                  name="venueId"
                                  onChange={(e) => {
                                    validation.setFieldValue(
                                      "venueId",
                                      e.target.value
                                    );
                                    setSelectedVenueForAdd(e.target.value);
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.venueId}
                                  invalid={
                                    validation.touched.venueId &&
                                    !!validation.errors.venueId
                                  }
                                >
                                  <option value="">Select Venue</option>
                                  {eventVenuesForAdd.map((venue) => (
                                    <option key={venue.value} value={venue.value}>
                                      {venue.label}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.venueId &&
                                  validation.errors.venueId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.venueId}
                                  </FormFeedback>
                                ) : null}

                              </FormGroup>
                            )} */}
                            {groupTicketList.length > 1 &&(
                              <>
                                <FormGroup>
                                  <Label>Group Ticket Name</Label>
                                  <Input
                                    type="select"
                                    name="groupingId"
                                    onChange={(e) => {
                                      console.log("e.target.value", e.target.value);
                                      validation.handleChange(e);
                                
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.groupingId}
                                    invalid={
                                      validation.touched.groupingId &&
                                      !!validation.errors.groupingId
                                    }
                                  >
                                    <option value="">Select Group</option>
                                    {groupTicketList.map((group: any) => (
                                      <option
                                        key={group.value}
                                        value={group.value}
                                      >
                                        {group.label || "Unnamed Group"}
                                      </option>
                                    ))}
                                  </Input>
                                  {validation.touched.groupingId &&
                                    validation.errors.groupingId ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.groupingId}
                                    </FormFeedback>
                                  ) : null}
                                </FormGroup>
                              </>
                            )}
                          </ModalBody>
                          <ModalFooter>
                            <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading}>
                               <h5>
                              {isLoading ? "Creating..." : "Create Ticket"}
                            </h5>

                            </Button>{" "}
                          </ModalFooter>
                        </Form>
                      </Modal>
                      <Modal isOpen={editModal} toggle={toggleEditModal}>
                        <ModalHeader toggle={toggleEditModal}>Edit Ticket</ModalHeader>
                        <Form onSubmit={editValidation.handleSubmit}>
                          <ModalBody className="px-4">
                            <FormGroup>
                              <Label className="form-label">Ticket Name</Label>
                              <Input
                                name="ticketType"
                                type="text"
                                value={editValidation.values.ticketType}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.ticketType && !!editValidation.errors.ticketType}
                              />
                              {editValidation.touched.ticketType && editValidation.errors.ticketType && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.ticketType}
                                </FormFeedback>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label className="form-label">Ticket Description</Label>
                              <Input
                                name="description"
                                type="text"
                                value={editValidation.values.description}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.description && !!editValidation.errors.description}
                              />
                              {editValidation.touched.description && editValidation.errors.description && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.description}
                                </FormFeedback>
                              )}
                            </FormGroup>

                            <FormGroup>
                              <Label className="form-label">Status</Label>
                              <Input
                                name="ticketStatus"
                                type="select"
                                value={editValidation.values.ticketStatus}
                                onChange={editValidation.handleChange}
                                onBlur={editValidation.handleBlur}
                                invalid={editValidation.touched.ticketStatus && !!editValidation.errors.ticketStatus}
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                                <option value="sold-out">Sold Out</option>
                              </Input>
                              {editValidation.touched.ticketStatus && editValidation.errors.ticketStatus && (
                                <FormFeedback type="invalid">
                                  {editValidation.errors.ticketStatus}
                                </FormFeedback>
                              )}
                            </FormGroup>
                          </ModalBody>
                          <ModalFooter>
                            <Button className="btn btn-primary mt-3 w-100 h_50" color="primary" type="submit" disabled={isLoading} >
                              <h5>
                              {isLoading ? "Saving..." : "Save Changes"}
                            </h5></Button>
                          </ModalFooter>
                        </Form>

                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <ToastContainer
                autoClose={2000}
                />
              </div>
            </div>
            {/* {isLoading ? (
              <div className="d-flex justify-content-center py-4">
                <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
              </div>
            ) : (
              <div className="event-list">
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="orders-tab"
                    role="tabpanel"
                  >
                    <NormalTable columns={columns} data={filteredTickets} getRowId={(row: any) => row.ticketTypeId} />
                  </div>
                </div>
              </div>
            )} */}
            <div className="mt-4">
            {filteredTickets.length > 0 ? (
              filteredTickets.map((filteredTicket:any) => (
                <ListCard
                  key={filteredTicket.ticketTypeId}
                  cardData={{
                    icon: "fa-solid fa-ticket",
                    name: filteredTicket.ticketType,
                    description: filteredTicket.description,
                    ticket: filteredTicket.groupName|| "N/A",
                    startDate: filteredTicket.createdAt,
                    status: filteredTicket.ticketStatus,
                    totalUsed: filteredTicket.currentCount,
                    totalLimit: filteredTicket.maxCount,
                    optionHead: "Price", 
                    option: filteredTicket.price, 
                    optionHead1: "Is Group Ticket (Count)",
                    option1: filteredTicket.isGroupTicket ? `Yes (${filteredTicket.groupTicketCount})` : "No",
                    optionIcon1: "fa-solid fa-users",
                  }}
                  onEdit={() => handleEdit(filteredTicket)}
                  onDelete={() => handleDelete(filteredTicket)}
                />
              ))
            ) : (
              <p className="text-muted">No tickets available</p>
            )}
          </div>
          </div>
        </div>
      </div>
      <NewTicketModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onSubmit={handleTicketSubmit}
        isLoading={isLoading}
        ticketKind={ticketKind}
        hasMultipleVenues={hasMultipleVenues}
        venues={venues}
        hasMultipleTicketGroups={hasMultipleTicketGroups}
        ticketGroups={ticketGroups}
        isTicketFree={isTicketFree}
      />
    </div>
  );
};

export default UserTickets;